import { render, staticRenderFns } from "./addCom.vue?vue&type=template&id=5f1277c8&scoped=true&"
import script from "./addCom.vue?vue&type=script&lang=js&"
export * from "./addCom.vue?vue&type=script&lang=js&"
import style0 from "./addCom.vue?vue&type=style&index=0&id=5f1277c8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f1277c8",
  null
  
)

component.options.__file = "addCom.vue"
export default component.exports